import React from "react";
import "./style.scss";

const SecondaryLoader = (props) => {
  return (
    <div
      className="loader"
      style={
        props.borderColor
          ? { border: `0.6rem solid ${props.borderColor}` }
          : { border: "0.6rem solid var(--primaryColor)" }
      }
    ></div>
  );
};

export default SecondaryLoader;
